import { blue, green, red } from '@mui/material/colors'
import { Device, GeoCoordinate, Spine, Valve } from '../types'
import { DeviceSignal } from '../enums/DeviceSignal'
import { DeviceType } from '../enums'

enum Helsinki {
  LAT = 60.169857,
  LONG = 24.938379
}

export function getDeviceGeoCoordinate(device: Device): GeoCoordinate {
  // FIXME: Throw error when device's geo coordinates cannot be
  // resolved instead of using Helsinki's coordinates as fallback.

  const lat =
    device?.asset?.project?.lat !== undefined && device?.asset?.project?.lat !== 0
      ? device?.asset?.project?.lat
      : Helsinki.LAT

  const long =
    device?.asset?.project?.long !== undefined && device?.asset?.project?.long !== 0
      ? device?.asset?.project?.long
      : Helsinki.LONG

  return {
    lat,
    long
  }
}

export function checkRssiColor(value: number) {
  if (value > -80 || value == -255) {
    return green[500]
  } else if (value == -254) {
    return blue[500]
  } else return red[500]
}

export function checkSignal(value: number) {
  if (value > -60) {
    return DeviceSignal.EXCELLENT as string
  } else if (value > -70) {
    return DeviceSignal.VERY_GOOD as string
  } else if (value > -80) {
    return DeviceSignal.GOOD as string
  } else if (value > -90) {
    return DeviceSignal.LOW as string
  } else if (value < -90 && value > -254) {
    return DeviceSignal.VERY_LOW as string
  } else if (value === -254) {
    return DeviceSignal.BLUETOOTH as string
  } else if (value === -255) {
    return DeviceSignal.SUB_DEVICE as string
  }
}

export function isValve(device: Device): device is Valve {
  return device.type === DeviceType.VALVE
}

export function isSpine(device: Device): device is Spine {
  return device.type === DeviceType.SPINE
}

export function isVirtualDevice(device: Device): boolean {
  return device.isVirtual
}

export function isNotVirtualDevice(device: Device): boolean {
  return !device.isVirtual
}
